import cn from './styles.module.sass';

interface IStatusProps {
    isSuccess?: boolean;
}

export const WithdrawalStatus = ({ isSuccess }: IStatusProps) => {
    return (
        <div className={cn.container}>
            <div className={cn.statusImg}>
                <img
                    src={`/images/main/${isSuccess ? 'success_reservation' : 'error'}.svg`}
                    alt=""
                />
            </div>
            <h2>{isSuccess ? 'Успешный вывод бонусов!' : 'Ошибка вывода'}</h2>
            <p>
                {isSuccess
                    ? 'В течение часа бонусы будут зачислены на баланс мобильного телефона'
                    : 'Отправь запрос на вывод бонусов еще раз'}
            </p>
        </div>
    );
};
